"use client";
import { jsxs as h, jsx as l } from "react/jsx-runtime";
const o = ({
  title: i,
  titleId: r,
  desc: t,
  descId: e,
  ...n
}) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-.5 -.5 24 24",
    "aria-hidden": "true",
    "data-slot": "icon",
    width: 24,
    height: 24,
    "aria-labelledby": r,
    "aria-describedby": e,
    ...n,
    children: [
      t ? /* @__PURE__ */ l("desc", { id: e, children: t }) : null,
      i ? /* @__PURE__ */ l("title", { id: r, children: i }) : null,
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m14.8542 19.1906-3.8334-3.8333 1.0302-1.0302 2.8032 2.8031 5.726-5.726 1.0302 1.0302zM20.125 9.272h-1.4375V4.3125H17.25v2.1563H5.75V4.3125H4.3125v14.375h6.0135v1.4375H2.875V2.875h6.277q.1678-.8385.8266-1.3776.659-.539 1.5214-.539t1.5214.539q.6588.5391.8265 1.3776h6.2771zM11.5 4.3125q.4072 0 .6828-.2755t.2755-.6828q0-.4074-.2755-.6828-.2756-.2756-.6828-.2756t-.6828.2756q-.2755.2754-.2755.6828 0 .4072.2755.6828t.6828.2755"
        }
      )
    ]
  }
);
export {
  o as default
};
